// extracted by css-extract-rspack-plugin
export default {"container":"HistoryWidget_container__8IjQG","headerContainer":"HistoryWidget_headerContainer__E+EO6","mobile":"HistoryWidget_mobile__srzov"};